export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_taskTime') || '任务编号',
    field: 'taskTime',
    headerAlign: 'center',
    align: 'left',
    width: 130,
    slots: { default: 'taskTime' },
  },
  {
    title: that.$l('table_label_taskTitle') || '任务概要',
    field: 'taskTitle',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'taskTitle' },
  },
  {
    title: that.$l('table_label_taskByName') || '经办人',
    field: 'tskByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskStatus') || '任务状态',
    field: 'taskStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'taskStatus' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_report_name') || '报告人',
    field: 'createByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tskEndDate') || '到期日期',
    field: 'tskEndDate',
    minWidth: 170,
    align: 'left',
    slots: { default: 'tskEndDate' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'createDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskUpdateTime') || '更新时间',
    field: 'modifyDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
]
